import { useCallback } from "react";
import { TabsState } from "./reducer";
import { useTabsState } from "./use-tabs-state";
import { useTabApiSync } from "./use-tab-api-sync";
import { isTemp } from "./utils";

export const useTabDeletion = (
  state: TabsState,
  actions: ReturnType<typeof useTabsState>["actions"],
  api: ReturnType<typeof useTabApiSync>,
) => {
  const { localTabs, deleteConfirmation } = state;
  const { openDeleteConfirm, closeDeleteConfirm } = actions;

  const handleDeleteClick = useCallback(
    (tabId: string) => {
      if (localTabs.length <= 1) return;
      const tab = localTabs.find((t) => t.id === tabId);
      if (!tab) return;
      // temporary tabs => hasContent false, otherwise determined by query
      openDeleteConfirm(tabId, tab.label, isTemp(tabId) ? false : false);
    },
    [localTabs, openDeleteConfirm],
  );

  const confirmDelete = useCallback(
    async (forceDelete: boolean) => {
      try {
        await api.confirmDelete(forceDelete);
        closeDeleteConfirm();
      } catch (error) {
        console.error("Error deleting tab:", error);
        closeDeleteConfirm();
      }
    },
    [api, closeDeleteConfirm],
  );

  const cancelDelete = useCallback(() => {
    closeDeleteConfirm();
  }, [closeDeleteConfirm]);

  return {
    deleteConfirmation,
    handleDeleteClick,
    confirmDelete,
    cancelDelete,
  } as const;
};
